@if (isDvfLoading()) {
  <div
    class="flex items-center justify-center gap-2.5 p-4 rounded-xl border border-primary-3/60 bg-primary-2/30 text-xs text-neutral-10"
  >
    <mat-spinner diameter="16"></mat-spinner>
    <span>Recherche des ventes réelles DVF (DGFiP) du secteur...</span>
  </div>
} @else if (dvfData(); as dvf) {
  <div class="rounded-xl border border-primary-3 bg-primary-2/40 p-4 text-left flex flex-col gap-3">
    <!-- Header with sales count badge -->
    <div class="flex items-center justify-between gap-2 border-b border-primary-3 pb-2.5">
      <div class="flex items-center gap-2">
        <mat-icon fontIcon="analytics" class="text-primary-10 text-[18px] w-4.5 h-4.5"></mat-icon>
        <span class="font-bold text-neutral-12 text-xs sm:text-sm tracking-wide">
          Repère marché DVF (DGFiP)
        </span>
      </div>
      <span class="text-xs font-semibold text-primary-11 bg-primary-3/60 px-2.5 py-0.5 rounded-full">
        {{ dvf.salesCount }} vente{{ dvf.salesCount > 1 ? 's' : '' }} actée{{ dvf.salesCount > 1 ? 's' : '' }}
      </span>
    </div>

    <!-- Key Metrics Grid -->
    <div class="grid grid-cols-1 sm:grid-cols-2 gap-3">
      <!-- Sector Median Price -->
      <div class="flex flex-col">
        <span class="text-xs font-medium text-neutral-11">Prix médian secteur</span>
        <span class="text-xl font-bold text-neutral-12">
          {{ dvf.medianPriceM2 | number: '1.0-0' : 'fr-FR' }} €/m²
        </span>
        @if (dvf.minPriceM2 && dvf.maxPriceM2) {
          <div
            class="mt-0.5 inline-flex items-center gap-1 cursor-help group w-fit"
            matTooltip="Fourchette constatée : prix au m² le plus bas et le plus haut enregistrés parmi les ventes réelles du secteur pour ce type de bien."
            matTooltipPosition="above"
          >
            <span
              class="text-xs text-neutral-10 border-b border-dashed border-neutral-6 group-hover:text-neutral-11 transition-colors"
            >
              {{ dvf.minPriceM2 | number: '1.0-0' : 'fr-FR' }} -
              {{ dvf.maxPriceM2 | number: '1.0-0' : 'fr-FR' }} €/m²
            </span>
            <mat-icon
              class="text-xs! w-3.5! h-3.5! text-neutral-8 group-hover:text-neutral-10 transition-colors"
            >
              info_outline
            </mat-icon>
          </div>
        }
      </div>

      <!-- Estimated Value for Property Surface -->
      @if (dvfEstimatedPrice(); as estimatedPrice) {
        <div class="flex flex-col">
          <span class="text-xs font-medium text-neutral-11">
            Valeur estimée pour {{ effectiveSurface() }} m²
          </span>
          <div class="flex items-center gap-2">
            <span class="text-xl font-bold text-primary-11">
              {{ estimatedPrice | number: '1.0-0' : 'fr-FR' }} €
            </span>
          </div>
          <div
            class="mt-0.5 inline-flex items-center gap-1 cursor-help group w-fit"
            matTooltip="Marge indicative de négociation (-10 % à +10 % autour du prix médian) : un écart supérieur à 10 ou 15 % par rapport au marché doit être motivé par des atouts ou points d'attention particuliers."
            matTooltipPosition="above"
          >
            <span
              class="text-xs text-neutral-10 border-b border-dashed border-neutral-6 group-hover:text-neutral-11 transition-colors"
            >
              {{ dvfEstimatedPriceMin() | number: '1.0-0' : 'fr-FR' }} € à
              {{ dvfEstimatedPriceMax() | number: '1.0-0' : 'fr-FR' }} €
            </span>
            <mat-icon
              class="text-xs! w-3.5! h-3.5! text-neutral-8 group-hover:text-neutral-10 transition-colors"
            >
              info_outline
            </mat-icon>
          </div>
        </div>
      }
    </div>

    <!-- DVF Position Gauge comparing to current/recommended price -->
    @if (showGauge() && dvf.medianPriceM2) {
      <div class="border-t border-primary-3/50 pt-3 mt-0.5">
        <etxe-property-dvf-gauge
          [currentPriceM2]="currentPriceM2()"
          [medianPriceM2]="dvf.medianPriceM2"
          [minPriceM2]="dvf.minPriceM2"
          [maxPriceM2]="dvf.maxPriceM2"
          [salesCount]="dvf.salesCount"
          [propertyType]="dvf.propertyType"
        />
      </div>
    }

    <!-- Official DGFiP Source Footer Link -->
    <div class="flex items-center border-t border-primary-3/60 pt-2 text-xs text-neutral-10 leading-tight">
      <a
        href="https://app.dvf.etalab.gouv.fr/"
        target="_blank"
        rel="noopener noreferrer"
        class="inline-flex items-center gap-1 font-semibold text-primary-10 hover:text-primary-11 underline underline-offset-2 shrink-0 transition-colors"
      >
        Source officielle DGFiP
      </a>
      <span>&nbsp;: actes notariés réels du quartier.</span>
    </div>
  </div>
}
